import React from 'react';
import AtlassianIntelligenceIcon from '@atlaskit/icon/core/atlassian-intelligence';
import { createOpenAIModalCommand } from '../../decoration/actions';
export var createGetNudgeFromConfigItem = function createGetNudgeFromConfigItem(_ref) {
  var editorView = _ref.editorView,
    configItem = _ref.configItem,
    aiGlobalOptIn = _ref.aiGlobalOptIn,
    intl = _ref.intl;
  return function (nudgeMetrics) {
    var _configItem$config$ic, _configItem$config;
    return {
      id: configItem.config.key,
      title: intl.formatMessage(configItem.config.title),
      description: intl.formatMessage(configItem.config.description),
      icon: ((_configItem$config$ic = (_configItem$config = configItem.config).icon) === null || _configItem$config$ic === void 0 ? void 0 : _configItem$config$ic.call(_configItem$config, {
        formatMessage: intl.formatMessage
      })) || /*#__PURE__*/React.createElement(AtlassianIntelligenceIcon, {
        label: "",
        spacing: "spacious"
      }),
      onClick: function onClick() {
        editorView.focus();
        createOpenAIModalCommand({
          state: editorView.state,
          configItem: configItem.config,
          lastTriggeredFrom: 'rovoButtonNudge',
          nudgeMetrics: nudgeMetrics,
          aiGlobalOptIn: aiGlobalOptIn
        })(editorView.state, editorView.dispatch);
      }
    };
  };
};